import React from 'react'
import { StyledRadioForm, Props } from './styled'

export const RadioForm: React.FC<Props> = (props: Props) => {
  return <StyledRadioForm {...props} />
}
